import React, { PropsWithChildren } from "react";

import { css, cx } from "@emotion/css";
import { QueryAwait } from "@steto-care/steto-query";

import { useStyles } from "@/hooks/useStyles.ts";
import { Theme } from "@/theme/CreateTheme.ts";
import { CenteredLoader } from "@/uiKit/atoms/pending/CenteredLoader.tsx";
import { AtomProps } from "@/uiKit/atoms/utils/AtomTypes.ts";
import { HandledErrorCard } from "@/uiKit/organisms/HandledErrorCard.tsx";

export type BaseCardContentProps = PropsWithChildren<{
  ref?: React.Ref<HTMLDivElement>;
  onScroll?: (event: React.UIEvent<HTMLDivElement>) => void;
}>;

export type CardContentProps = AtomProps<BaseCardContentProps>;

export const CardContent: React.FC<CardContentProps> = ({ children, className, ...props }) => {
  const styles = useStyles(makeStyles);

  return (
    <div className={cx(styles.root, "scrollbar", className)} {...props}>
      <QueryAwait errorFallback={HandledErrorCard} pendingFallback={CenteredLoader}>
        {children}
      </QueryAwait>
    </div>
  );
};

const makeStyles = (theme: Theme) => ({
  root: css({
    flex: "1 1",
    overflow: "auto",
    padding: theme.spacing(8, 12, 0, 12),
  }),
});
